import React, { useState, } from 'react';
import '../../../css/Form.css';
import Select from 'react-select';
import ERPUtils from '../../../helper/Utils';
// import Tooltip from '@mui/material/Tooltip';
// import Zoom from '@mui/material/Zoom';
import UploadFile from '../../../helper/UploadFile';

const ResearchDetails = (props) => {
	const {
		onChangeHandler,
		vacancySources,
		saveDraft,
		SelectHandler,
		ResearchData,
		ResearchDetailsHandler,
		ValidationError,
		ResearchDetailsData,
		userDetails,
		setUserDetails,
		addInfoMaxVal,
		addInfoEnteredVal,
		handleRenderComp,
		topFunction,
		scrollToBottom,
		onDataSave,
		// onFileChange,
		// imageRemoveHandler,
		// openImageInTab,
		loadOrcidData,
		// requiredFields,
		// dashboardHandler,
		// LockDashboard,
		scrollHandler,
		UploadData,
		setSaveTheData

	} = props;
	let hide = [];
	const [imageUploadError, setImageUploadError] = useState(null);
	// methods for image size setting before upload
	const whenReady = (error) => {
		setImageUploadError(error);
	}
	//UPLOAD COMPONENT DATA SETTING
	const uploadProcessCode = "EMPLOYEE_APP_PHOTO";
	const processCodeData = UploadData.filter((item) => item.uploadProcessCode === uploadProcessCode)

	const resumeUploadProcesscode = "EMP_RESUME_UPLOAD";
	const resumeUploadProcesscodeData = UploadData.filter(
		(item) => item.uploadProcessCode === resumeUploadProcesscode
	);


	// const checkSize = (event) => {
	// 	isPassportSizeImage(event)
	// }
	// const ACCEPTED_FORMATS = ['image/jpeg', 'image/png'];
	// // Define the maximum and minimum dimensions of the photo
	// const max_width = 35; // in mm
	// const max_height = 45; // in mm
	// const min_width = 33; // in mm
	// const min_height = 43; // in mm

	// // Define the maximum file size of the photo
	// const max_size = 300 * 1024; // in bytes

	// const dpi = 300; // for a standard passport size photo


	// function isPassportSizeImage(event) {

	// 	let file = event.target.files[0];
	// 	if (!ACCEPTED_FORMATS.includes(file?.type)) {
	// 		// Check if file is in accepted formats
	// 		whenReady("Only JPEG and PNG images accepted");
	// 	}
	// 	if (file.size > max_size) {
	// 		whenReady("The file size is too large. Please upload a photo with a file size less than 300KB.");
	// 	}
	// 	var reader = new FileReader();
	// 	reader.onload = function (e) {
	// 		var img = new Image();
	// 		img.onload = function () {
	// 			const width = this.width;
	// 			const height = this.height;
	// 			const mm_width = (width / dpi) * 25.4;
	// 			const mm_height = (height / dpi) * 25.4;
	// 			// Check if the dimensions are within the allowed range
	// 			if (mm_width < min_width || mm_height < min_height || mm_width > max_width || mm_height > max_height) {
	// 				whenReady("The dimensions of the photo should be 35x45mm.");
	// 			} else {
	// 				setImageUploadError(null)
	// 				onFileChange(event, 'ResearchDetailsImg', false)
	// 			}
	// 		};
	// 		img.src = e.target.result;
	// 	};
	// 	reader.readAsDataURL(file);
	// 	// return isValid;
	// }

	const getUploadData = (data) => {
		whenReady("")
		let newState = { ...userDetails };
		newState.profilePhoto = data
		setUserDetails(newState);
		setSaveTheData(true);
	};

	const getResumeUploadData = (data) => {
		whenReady("");
		let newState = { ...userDetails };
		newState.resume = data
		setUserDetails(newState);
		setSaveTheData(true);
	};
	
	const getErrorMsg = (msg) => {
		whenReady(msg)
	}

	return (
		<div className="appForm" id='APP-FORM' onScroll={scrollHandler}
			style={{ height: window.innerWidth > 800 ? window.innerHeight - 240 : window.innerWidth <= 375 ? window.innerHeight - 275 : window.innerWidth <= 425 ? window.innerHeight - 260 : window.innerHeight - 260, overflowY: "auto" }}>
			<div className="animated zoomIn">
				<div className="row">
					<div className="col-md-6 col-sm-6">
						{/* <button
							className={LockDashboard ? 'disabledDashboardBtn' : 'backtoDashboardBtn'}
							onClick={dashboardHandler}
							disabled={LockDashboard}
						>
							<i className="fa fa-arrow-left backIcon" />Back to dashboard
						</button> */}
					</div>
					<div className="col-md-6 col-sm-6">
						<p className="requiredHeader  ">
							<span className="requiredTextHeading">*</span> These fields are required
						</p>
					</div>
				</div>
				<div className="formWrapper">
					<div className="row">
						<div className="col-md-5 col-xs-12">
							<label className="researchFormLabel ">
								Do you have Research Experience?
							</label>
						</div>
						<div className="col-md-4" style={{ top: '12px' }}>
							<label className="radio-inline">
								<input
									onChange={onChangeHandler}
									className="space"
									type="radio"
									name="ResearchExperience"
									value="Yes"
									checked={userDetails.ResearchExperience === 'Yes'}
								/>Yes
							</label>
							<label className="radio-inline">
								<input
									onChange={onChangeHandler}
									className="space"
									type="radio"
									name="ResearchExperience"
									value="No"
									checked={userDetails.ResearchExperience === 'No'}
								/>No
							</label>
						</div>
					</div>
				</div>

				{userDetails.ResearchExperience === 'Yes' ? (
					<div className="animated zoomIn">
						<div className="formWrapper">
							<div className="row">
								<div className="col-md-5 col-xs-12">
									<label className="researchFormLabel ">
										ORCID
									</label>
									{/* <span className="requiredText">*</span> */}
								</div>
								<div className="col-md-4">
									<input
										className={
											ValidationError.orcidIdError ? (
												'form-control invalid z-depth-3'
											) : (
												'form-control z-depth-3'
											)
										}
										value={userDetails.orcidId}
										type="text"
										name="orcidId"
										onChange={onChangeHandler}
										placeholder="ORCID"
										maxLength={19}
									/>
									{userDetails.orcidId.length > 0 && ValidationError.orcidIdError === false ? (
										<span
											className='link link-primary emp-appl-custom-link'
											onClick={loadOrcidData}
											style={{ width: '100%', float: 'right', textAlign: 'right' }}
											tabIndex={0}
											role='button' onKeyDown={(e) => {
												if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
													loadOrcidData(e)
											}}
										>
											View Details
										</span>
									) : null}
									{/* {ValidationError.orcidIdError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter a valid ORCID
										</p>
									) : null} */}
									{/* {requiredFields.commonErrors[0].orcidIdReqError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />
											ORCID cannot be empty
										</p>
									) : null} */}
								</div>
							</div>
						</div>

						<div className="formWrapper">
							<div className="row">
								<div className="col-md-5 col-xs-12">
									<label className="researchFormLabel ">
										VIDWAN ID
									</label>
								</div>
								<div className="col-md-4">
									<input
										className={
											ValidationError.vidwanIdError ? (
												'form-control invalid z-depth-3'
											) : (
												'form-control z-depth-3'
											)
										}
										value={userDetails.vidwanId}
										type="text"
										name="vidwanId"
										onChange={onChangeHandler}
										placeholder="Vidwan ID"
										maxLength="11"
									/>
									{ValidationError.vidwanIdError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter a valid Vidwan Id
										</p>
									) : null}
								</div>
							</div>
						</div>

						<div className="formWrapper">
							<div className="row">
								<div className="col-md-5 col-xs-12">
									<label className="researchFormLabel ">
										Scopus ID
									</label>
								</div>
								<div className="col-md-4">
									<input
										type="text"
										placeholder="Scopus ID"
										className={
											ValidationError.scopusPaperNumberError ? (
												'form-control invalid z-depth-3'
											) : (
												'form-control z-depth-3'
											)
										}
										name="scopusPaperNumber"
										value={userDetails.scopusPaperNumber}
										onChange={onChangeHandler}
										maxLength="11"
									/>
									{ValidationError.scopusPaperNumberError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter a valid Scopus Id
										</p>
									) : null}
								</div>
							</div>
						</div>

						<div className="formWrapper">
							<div className="row">
								<div className="col-md-5 col-xs-12">
									<label className="researchFormLabel ">
										Current Scopus h-index
									</label>
								</div>
								<div className="col-md-4">
									<input
										type="text"
										placeholder="H-Index"
										className={
											ValidationError.hIndexError ? (
												'form-control invalid z-depth-3'
											) : (
												'form-control z-depth-3'
											)
										}
										name="hIndex"
										value={userDetails.hIndex}
										onChange={onChangeHandler}
										maxLength="7"
									/>
									{ValidationError.hIndexError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter a valid H-Index
										</p>
									) : null}
								</div>
							</div>
						</div>
						{ERPUtils.isUndefinedOrNull(ResearchData) === false ? (
							ResearchData.map((els, id) => {
								els.detailsDTO.map((items) => {
									if (items.isDisplayInApplication === true) {
										if (ERPUtils.isUndefinedOrNull(hide[els.label]) || hide[els.label] === true) {
											return (hide[els.label] = false);
										}
									} else {
										if (ERPUtils.isUndefinedOrNull(hide[els.label])) {
											return (hide[els.label] = true);
										}
									}
									return '';
								});
								return '';
							})
						) : null}
						{ERPUtils.isUndefinedOrNull(ResearchData) === false ? (
							ResearchData.map((el, index) => {
								if (el.isTypeResearch === true && el.employeeCategoryId === userDetails.Post.value) {
									if (el.detailsDTO.length > 0) {
										let mainName = el.label;
										return (
											<div key={index}>
												{hide[el.label] === true ? null : (
													<div className="formWrapper">
														<div className="row">
															<div className="col-md-5 col-xs-12">
																<h4 className="appFormLabel ResearchHeaders ">
																	{el.label}
																</h4>
															</div>
														</div>
													</div>
												)}
												{el.detailsDTO.map((item, idx) => {
													let childName = item.label;
													if (item.isDisplayInApplication === true) {
														return (
															<div key={idx} className="formWrapper">
																<div className="row">
																	<div className="col-md-5 col-xs-12">
																		<label className="appFormLabel ResearchSubHeaders ">
																			{item.label}
																		</label>
																	</div>
																	<div className="col-md-4 helperDiv">
																		{/* <Tooltip
																			enterDelay={300}
																			leaveDelay={200}
																			enterTouchDelay={1}
																			TransitionComponent={Zoom}
																			leaveTouchDelay={5000}
																			title={
																				<span className="toolTip">{`Enter the number of ${el.label} in ${item.label}`}</span>
																			}
																			placement="top"
																			arrow
																		>
																			<p> */}
																		<input
																			type="text"
																			className={
																				ValidationError[
																					mainName +
																					childName +
																					'Error'
																				] ? (
																					'form-control invalid ResearchSubHeadersLabel z-depth-3'
																				) : (
																					'form-control ResearchSubHeadersLabel z-depth-3'
																				)
																			}
																			name={item.label}
																			id={el.label}
																			value={
																				ERPUtils.isUndefinedOrNull(
																					ResearchDetailsData[
																					mainName
																					]
																				) ===
																					false ? ERPUtils.isUndefinedOrNull(
																						ResearchDetailsData[
																						mainName
																						][childName]
																					) === false ? (
																					ResearchDetailsData[
																					mainName
																					][childName]
																				) : (
																					''
																				) : (
																					''
																				)
																			}
																			onChange={ResearchDetailsHandler}
																			maxLength="1000"
																		/>
																		{/* </p>
																		</Tooltip> */}
																		{/* <div class = 'helperText'>{` number of`}</div> */}

																		{ValidationError[
																			mainName + childName + 'Error'
																		] ? (
																			<p className="ValidationError">
																				<i className="fa fa-warning warningIcon" />&nbsp;
																				Please enter a valid number
																			</p>
																		) : null}
																	</div>
																</div>
															</div>
														);
													}
													return '';
												})}
											</div>
										);
									}
								}
								return '';
							})
						) : null}
					</div>
				) : null}
				{userDetails.ResearchExperience === 'Yes' ? <><div className="appDivider" />
					<h5>
						Other Details
					</h5></> : ""}



				<div className="formWrapper">

					<div className="row">

						<div className="col-md-5 col-xs-12">
							<label className="researchFormLabel ">
								Upload Candidate’s Photo
								<span className='d-block' >
									<span className='upload-accepted-format-indication' > ({"Allowed file types:" + processCodeData[0]?.fileTypeList.join(',')})</span>
									<span className='upload-accepted-format-indication'>{"(Photograph  should be passport size with white background)"}</span>
								</span>
							</label>
						</div>

						<div className="col-lg-3 file-field d-flex align-items-center">
							<div className=''>
								{/* <label className="upload-btn">
									<input
										type="file"
										className='emp-appl-custom-link '
										onChange={(e) => checkSize(e)}
										accept="image/*"
										id="0"
									/>Upload
								</label> */}
								<UploadFile
									callback={getUploadData}
									data={userDetails.profilePhoto}
									keyList={processCodeData}
									id={uploadProcessCode}
									errorCallBack={getErrorMsg}
								/>


								{!ERPUtils.isNullorWhiteSpace(imageUploadError) ?
									<p className="ValidationError" style={{ fontSize: "12px" }}>
										<i className="fa fa-warning warningIcon"></i>&nbsp;
										{imageUploadError}
									</p> : null}
							</div>
						</div>

						{/* <div className="col-md-5 col-xs-12">
							<label className="researchFormLabel ">
								Upload Candidate’s Resume
								<span className='d-block' >
									<span className='upload-accepted-format-indication' >({"Allowed file types:" + resumeUploadProcesscodeData[0]?.fileTypeList.join(',')})</span>
									<span className='upload-accepted-format-indication'>({"File size limit: less than" + " " + resumeUploadProcesscodeData[0]?.fileSizeInKB + "kb"})</span>
								</span>
							</label>
						</div> */}

						{/* <div className="col-lg-3 file-field d-flex align-items-center">
							<div className=''>
								<UploadFile
									callback={getResumeUploadData}
									data={userDetails.resume}
									keyList={resumeUploadProcesscodeData}
									id={resumeUploadProcesscode}
									errorCallBack={getErrorMsg}
									isMulti={false}
									userDetails={userDetails}
								/>


								{!ERPUtils.isNullorWhiteSpace(imageUploadError) ?
									<p className="ValidationError" style={{ fontSize: "12px" }}>
										<i className="fa fa-warning warningIcon"></i>&nbsp;
										{imageUploadError}
									</p> : null}
							</div>
						</div> */}

						{/* {userDetails.ResearchDetailsImg[0].Documents.length > 0 ? (
								userDetails.ResearchDetailsImg[0].Documents.map((el, idx) => {
									if (el.recordStatus === 'A') {
										return (
						<div className="col-md-4" key={idx}>
											<div style={{ display: 'inline-block' }} >
												<p className="z-depth-3 imgTab d-flex p-2">
													<span style={{ width: "140px", textOverflow: "ellipsis", overflow: "hidden", display: "block" }}>
														{el.originalFileName}
													</span>
													<span style={{ width: "30px", display: "block" }}>
														<i
															className="fa fa-times imageRemoveIcon"
															onClick={(event) =>
																imageRemoveHandler(event, 'ResearchDetailsImg', 0)}
															id={idx}
															title="Delete"
														/>
													</span>
												</p>
												<img
													className="img-rounded z-depth-3 imgStyle"
													src={el.url}
													alt={el.fileName}
													onClick={openImageInTab}
												/>
											</div>
						</div>
										);
									}
								})
							) : null} */}
					</div>

				</div>



				<div className="formWrapper">
					<div className="row">
						<div className="col-md-5 col-xs-12">
							<label className="researchFormLabel ">
								Have you ever been interviewed at CHRIST?
							</label>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-12" style={{ top: '12px' }}>
							<label className="radio-inline">
								<input
									onChange={onChangeHandler}
									type="radio"
									className="space"
									name="interviewedBefore"
									value="Yes"
									checked={userDetails.interviewedBefore.toString() === 'Yes'}
								/>Yes
							</label>
							<label className="radio-inline">
								<input
									onChange={onChangeHandler}
									type="radio"
									className="space"
									name="interviewedBefore"
									value="No"
									checked={userDetails.interviewedBefore.toString() === 'No'}
								/>No
							</label>
						</div>
					</div>
				</div>

				{userDetails.interviewedBefore.toString() === 'Yes' ? (
					<div>
						<div className="formWrapper">
							<div className="row">
								<div className="col-md-5 col-xs-12">
									<label className="researchFormLabel ResearchSubHeaders ">
										Department
									</label>
								</div>
								<div className="col-md-4">
									<input
										onChange={onChangeHandler}
										type="text"
										value={userDetails.InterviewedDept}
										name="InterviewedDept"
										className="form-control z-depth-3"
										maxLength="50"
									/>
								</div>
							</div>
						</div>
						<div className="formWrapper">
							<div className="row">
								<div className="col-md-5 col-xs-12">
									<label className="researchFormLabel ResearchSubHeaders ">
										Year
									</label>
								</div>
								<div className="col-md-4">
									<input
										onChange={onChangeHandler}
										type="text"
										name="InterviewedYear"
										value={userDetails.InterviewedYear}
										className="form-control z-depth-3"
										maxLength="4"
									/>
									{ValidationError.InterviewedYearError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter a valid Year
										</p>
									) : null}
								</div>
							</div>
						</div>

						<div className="formWrapper">
							<div className="row">
								<div className="col-md-5 col-xs-12">
									<label className="researchFormLabel ResearchSubHeaders ">
										Application No
									</label>
								</div>
								<div className="col-md-4">
									<input
										onChange={onChangeHandler}
										type="text"
										name="InterviewedApplNo"
										value={userDetails.InterviewedApplNo}
										className="form-control z-depth-3"
										maxLength="11"
										onKeyDown={ERPUtils.isValidNumber}
									/>
									{ValidationError.InterviewedApplNoError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter a valid Application
											No
										</p>
									) : null}
								</div>
							</div>
						</div>

						<div className="formWrapper">
							<div className="row">
								<div className="col-md-5 col-xs-12">
									<label className="researchFormLabel ResearchSubHeaders ">
										Subject
									</label>
								</div>
								<div className="col-md-4">
									<input
										onChange={onChangeHandler}
										type="text"
										name="InterviewedSubject"
										value={userDetails.InterviewedSubject}
										className="form-control z-depth-3"
										maxLength="50"
									/>
								</div>
							</div>
						</div>
					</div>
				) : null}

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-5 col-xs-12">
							<label className="researchFormLabel ">
								How did you know about vacancy/Position?
							</label>
						</div>
						<div className="col-md-4">
							<Select
								className="z-depth-3"
								value={userDetails.vacancySource}
								onChange={(selected) => SelectHandler(selected, 'vacancySource')}
								options={vacancySources}
								placeholder="Select"
								isClearable
							/>
						</div>
					</div>
				</div>

				{userDetails.vacancySource.label === ('Others' || 'others') ? (
					<div className="formWrapper">
						<div className="row">
							<div className="col-md-5 col-xs-12">
								<label className="appFormLabel ">
									Others
								</label>
							</div>
							<div className="col-md-4">
								<input
									type="text"
									className="form-control z-depth-3"
									name="SourceOthers"
									value={userDetails.SourceOthers}
									onChange={onChangeHandler}
									maxLength="100"
								/>
							</div>
						</div>
					</div>
				) : null}

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-5 col-xs-12">
							<label className="researchFormLabel ">
								Please enter any additional information (Optional)
							</label>
						</div>
						<div className="col-md-4">
							<textarea
								className="form-control z-depth-3"
								rows="5"
								name="OtherInformation"
								onChange={onChangeHandler}
								value={userDetails?.OtherInformation}
								maxLength="5000"
							/>
							<span
								className=""
								style={{ float: 'right', marginTop: '4px' }}
							>{`${addInfoMaxVal - userDetails?.OtherInformation?.length} characters left`}</span>
						</div>
					</div>
				</div>
				<br />
				<div className="appDivider" />
				<div className="formWrapper">
					<div className="row">
						<div className="col-sm-4 parentDiv">
							<button
								className="PreviousButton z-depthButton"
								value="Previous"
								name="ProfessionalExperience"
								onClick={() => handleRenderComp("ProfessionalExperience")}
							>
								<i className="fas fa-chevron-left mr-3" name="ProfessionalExperience" style={{ color: "#ffffff" }} ></i>
								Previous
							</button>
						</div>
						<div className="col-sm-4 parentDiv">
							<button
								className="saveDraftButton z-depthButton"
								value="Save Draft"
								name="saveDraft"
								onClick={saveDraft}
							>
								Save Draft
							</button>
						</div>
						<div className="col-sm-4 parentDiv">
							<button className="saveButton z-depthButton" value="Save" name="save" onClick={onDataSave}>
								Submit
							</button>
						</div>
					</div>
				</div>

				<button onClick={topFunction} id="myBtnUp">
					<div className="UpArrow" />
				</button>
				<button onClick={scrollToBottom} id="myBtnDown">
					<div className="downArrow" />
				</button>

			</div>
		</div>
	);
};

export default ResearchDetails;
